<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SDBuUv/tc-custom/9781514001134.jpg?1696870396655" alt="This image is the cover for the book Covenantal and Dispensational Theologies, Spectrum Multiview Book Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Covenantal and Dispensational Theologies, Spectrum Multiview Book Series
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>How does the canon of Scripture fit together?</strong> </p> <p>For evangelical Christians, there is no question about the authority of Scripture and its testimony to the centrality of Jesus Christ in God's salvation plan. But several questions remain: How do the Old Testament and New Testament relate to each other? What is the relationship among the biblical covenants? How should Christians read and interpret Scripture in order to do justice to both its individual parts and its whole message? How does Israel relate to the church?</p> <p>In this Spectrum Multiview volume, readers will find four contributors who explore these complex questions. The contributors each make a case for their own view—representing two versions of covenantal theology and two versions of dispensational theology—and then respond to the others' views to offer an animated yet irenic discussion on the continuity of Scripture.</p> <p>Views and Contributors:</p>  Covenant Theology: Michael S. Horton, Gresham Machen Professor of Systematic Theology and Apologetics, Westminster Seminary California Progressive Covenantalism: Stephen J. Wellum, professor of Christian theology, Southern Baptist Theological Seminary Progressive Dispensationalism: Darrell L. Bock, Senior Research Professor of New Testament Studies, Dallas Theological Seminary Traditional Dispensationalism: Mark A. Snoeberger, professor of systematic theology and apologetics, Detroit Baptist Theological Seminary  <p>Spectrum Multiview Books offer a range of viewpoints on contested topics within Christianity, giving contributors the opportunity to present their position and also respond to others in this dynamic publishing format.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brent E. Parker, Richard J. Lucas
      </h2>
      
      <p class="authorDescription body article"><p>Brent E. Parker (PhD, Southern Baptist Theological Seminary) is assistant editor of <em>The Southern Baptist Journal of Theology</em> and the coeditor of <em>Progressive Covenantalism: Charting a Course Between Dispensational and Covenantal Theologies</em>. </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32590906